import { createAction } from 'redux-actions'
import axios from 'axios';

// 派发任务
export const getnewTasksSucceeded = createAction('newTasks/GET_SUCCEEDED')
export const getnewTasksFailed = createAction('newTasks/GET_FAILED')

export function fetchGetnewTasks(params) {
  return dispatch => (
    axios.post('/api/job/sendJobs', params)
      .then(response => dispatch(getnewTasksSucceeded(response)))
      .catch(error => dispatch(getnewTasksFailed(error)))
  )
}




// WEBPACK FOOTER //
// ./actions/newTasks.js